import { render, staticRenderFns } from "./Excursiones.vue?vue&type=template&id=3f41d5fc&"
import script from "./Excursiones.vue?vue&type=script&lang=js&"
export * from "./Excursiones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports